import React from "react";
import PropTypes from "prop-types";
import { RichText } from "prismic-dom";
import { Box } from "rebass";
import {
  Head,
  H2,
  Text,
  Article,
  Main,
  PageHeader,
  PageSidebar,
  PageContent,
  PageSection,
  CalloutCard,
  Accordion,
} from "components";

let linkResolver = function (doc) {
  return "/" + doc.type;
};

class Reports extends React.Component {
  static contextTypes = {
    setAltLanguages: PropTypes.func,
  };
  componentDidMount() {
    this.context.setAltLanguages(undefined);
  }

  render() {
    let json = "";

    if (this.props.data.reports.raw) {
      json = JSON.parse(this.props.data.reports.raw);
    }
    return (
      <Box
        style={
          this.props.transition ? this.props.transition.style : { opacity: 0 }
        }
      >
        <Head source={json.data} />
        <Main>
          <PageHeader title={json.data.title[0].text} color={json.uid}>
            {json.data.subtitle[0] && (
              <H2 children={json.data.subtitle[0].text} fontSize={[4, 5]} />
            )}
            {json.data.description[0] && (
              <Text children={json.data.description[0].text} />
            )}
          </PageHeader>
          <PageSection>
            {json.data.body1[0] && (
              <PageSidebar>
                {json.data.body1.map((callout, index) => (
                  <CalloutCard
                    key={"callout" + index}
                    callout={callout.primary}
                    lang={json.lang}
                  />
                ))}
              </PageSidebar>
            )}
            <PageContent>
              <Box>
                {json.data.accordions.map((accordion, index) => (
                  <Accordion
                    key={"Accordion" + index}
                    title={
                      accordion.accordion_title[0]
                        ? accordion.accordion_title[0].text
                        : ""
                    }
                    data={[]}
                  >
                    {accordion.accordion_content && (
                      <Article
                        dangerouslySetInnerHTML={{
                          __html: RichText.asHtml(
                            accordion.accordion_content,
                            linkResolver
                          ),
                        }}
                      />
                    )}
                  </Accordion>
                ))}
              </Box>
            </PageContent>
          </PageSection>
        </Main>
      </Box>
    );
  }
}

export default Reports;

export const query = graphql`
  query ReportsQuery($id: String!) {
    reports: prismicDocument(prismicId: { eq: $id }) {
      uid
      id
      raw
      lang
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/reports.js